/**
 * 코드 관리 화면의 경로·라우트 이름·메뉴 link 상수 (단일 출처).
 *
 * @MX:NOTE: [AUTO] menuLink = DB 메뉴 등록 화면의 「링크명」 = 서버 권한 판정 link. 셋이 정확히 같아야 한다.
 *   router.enums.js 대신 이 파일을 쓰는 이유: scripts/contracts-v5-preserve-check.js 가
 *   router.enums.js 무변경을 단언한다 (SPEC-MFR-CODE-MANAGEMENT-001 CON-03).
 *
 * 사이드바 노출은 메뉴 데이터(role=MANUFACTURER)와 계정별 권한으로만 결정한다(CON-01).
 * 여기에 있는 값은 라우트 등록과 화면 권한 판정에만 쓴다.
 */
export const CODE_MANAGEMENT = {
    path: '/code-management',
    name: 'CodeManagement',
};

export const HANDPIECE_BARCODE = {
    path: 'handpiece-barcode',
    name: 'CodeManagementHandpieceBarcode',
    menuLink: '/code-management/handpiece-barcode',
};

export const GENUINE_TIP_CODE = {
    path: 'genuine-tip-code',
    name: 'CodeManagementGenuineTipCode',
    menuLink: '/code-management/genuine-tip-code',
};
